export default __webpack_public_path__ + "static/media/SpringFestival_12.40f6fbd0.png";